module.exports = __webpack_public_path__ + "img/coupon_tutorial_lalamee02.a5364b81.jpg";